import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import '../../assets/custom.css'
import { getCart } from '../../Redux/ActionCreator/CartActionCreator'
import { useDispatch, useSelector } from 'react-redux'

export default function Navbar() {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    let navigate = useNavigate()
    let dispatch = useDispatch()
    let [cart, setCart] = useState(0)
    let CartStateData = useSelector(state => state.CartStateData)
    let ProductStateData = useSelector(state => state.ProductStateData)

    function logout() {
        localStorage.removeItem("login")
        localStorage.removeItem("name")
        localStorage.removeItem("userid")
        navigate('/login')
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);

        if (value.length > 0) {
            const filteredData = ProductStateData.filter((item) => item.name.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filteredData);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const clearSearch = () => {
        setQuery('');
        setShowSuggestions(false);
    };

    const handleSuggestionClick = (suggestion) => {
        setQuery(suggestion.name);
        setShowSuggestions(false);
    };

    useEffect(() => {
        dispatch(getCart())
        if (CartStateData.length)
            setCart(CartStateData.length)
        else
            setCart(0)
    }, [CartStateData.length])

    return (
        <>
            <div className=" sticky-top">
                <nav className="navbar navbar-light bg-white navbar-expand-xl py-1">
                    <div className='container '>
                        <Link to="/" className="navbar-brand mt-2"><h1>Mini<span className='text-info'>Store</span></h1></Link>
                        <div className='d-flex d-md-none d-lg-none mobile-cart'>
                            {
                                localStorage.getItem("login") ? <>
                                    <div className='d-flex align-items-center'>
                                        <div className="nav-item dropdown ">
                                            <Link to="#" className="nav-link dropdown-toggle text-dark" data-bs-toggle="dropdown">{localStorage.getItem("name").split(" ")[0]}</Link>
                                            <div className="dropdown-menu m-0 rounded-0">
                                                {
                                                    localStorage.getItem("role") === "Buyer" ?
                                                        <>
                                                            <Link to="/profile" className="dropdown-item"><i className='fa fa-user pe-2 text-dark'></i> My Profile</Link>
                                                            <Link to="/order" className="dropdown-item"><i className='fa fa-shopping-bag pe-2 text-dark'></i> Order</Link>
                                                            <Link to="/wishlist" className="dropdown-item"><i className='fa fa-heart pe-2 text-dark'></i> Wishlist</Link>
                                                        </> :
                                                        <Link to="/profile" className="dropdown-item"><i className='fa fa-user pe-2'></i> My Profile</Link>
                                                }
                                                <button onClick={logout} className="dropdown-item"><i className='fa fa-sign-out-alt pe-2'></i> Logout</button>
                                            </div>

                                        </div>
                                    </div></>
                                    :
                                    <div className='nav-item'>
                                        <Link to="/login" className="border border-info px-2 py-1 rounded-pill login-btn me-4">Login</Link>
                                    </div>
                            }
                            <Link to="/cart" className="position-relative me-4 my-auto">
                                <i className="fa fa-shopping-cart text-dark nav-icon" style={{ fontSize: "18px" }}></i>
                                <span className="position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center text-white px-1" style={{ top: "-5px", left: "15px", height: "15px", minWidth: "15px", fontSize: "10px" }}>{localStorage.getItem("login") ? cart : 0}</span>
                            </Link>
                        </div>
                        <button className="navbar-toggler py-0 px-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                            <span className="fa fa-bars text-info"></span>
                        </button>
                        <div className="collapse navbar-collapse bg-white" id="navbarCollapse">
                            <div className="input-group ms-md-5 ms-lg-5">
                                <span className="input-group-text">🔍</span>
                                <input type="text" className="form-control custom-input" placeholder="Search Product You Want..." value={query} onChange={handleInputChange}
                                />
                                {query && (
                                    <button className="btn btn-outline-info" onClick={clearSearch}>✖</button>
                                )}
                            </div>
                            {showSuggestions && suggestions.length > 0 && (
                                <ul className="list-group position-absolute ms-md-5 ms-lg-5 me-2" style={{ top: '100%', zIndex: '1000' }}>
                                    {suggestions.map((suggestion, index) => (
                                        <li key={suggestion._id} className="list-group-item list-group-item-action" onClick={() => handleSuggestionClick(suggestion)}>
                                            {suggestion.name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <div className="icon-link d-none d-md-flex d-lg-flex mx-0 w-100 gap-4 align-items-center justify-content-center">
                                {
                                    localStorage.getItem("login") ? <>
                                        <div className='d-flex align-items-center'>
                                            <i className='fa fa-user-circle nav-icon-1 '></i>
                                            <div className="nav-item dropdown ">
                                                <Link to="#" className="nav-link dropdown-toggle text-dark" data-bs-toggle="dropdown">{localStorage.getItem("name").split(" ")[0]}</Link>
                                                <div className="dropdown-menu m-0 rounded-0">
                                                    {
                                                        localStorage.getItem("role") === "Buyer" ?
                                                            <>
                                                                <Link to="/profile" className="dropdown-item"><i className='fa fa-user pe-2 text-dark'></i> My Profile</Link>
                                                                <Link to="/order" className="dropdown-item"><i className='fa fa-shopping-bag pe-2 text-dark'></i> Order</Link>
                                                                <Link to="/wishlist" className="dropdown-item"><i className='fa fa-heart pe-2 text-dark'></i> Wishlist</Link>
                                                            </> :
                                                            <Link to="/profile" className="dropdown-item"><i className='fa fa-user pe-2'></i> My Profile</Link>
                                                    }
                                                    <button onClick={logout} className="dropdown-item"><i className='fa fa-sign-out-alt pe-2'></i> Logout</button>
                                                </div>

                                            </div>
                                        </div></>
                                        :
                                        <div className='nav-item'>
                                            <Link to="/login" className="border border-info px-3 py-1 rounded-pill">Login</Link>
                                        </div>
                                }
                                <Link to="/cart" className="position-relative mx-4 my-auto">
                                    <i className="fa fa-shopping-cart text-dark nav-icon"></i>
                                    <span className="position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center text-white px-1" style={{ top: "-5px", left: "15px", height: "20px", minWidth: "20px" }}>{localStorage.getItem("login") ? cart : 0}</span>
                                </Link>

                                <div className='d-flex justify-content-center align-items-center'>
                                    <i className='fa fa-store nav-icon'></i>
                                    <Link to="/admin" className="nav-item  nav-link text-dark">Become a Seller</Link>
                                </div>
                            </div>
                            <div className="nav-item dropstart dropdown nav-dot d-none d-md-block">
                                <Link to="#" className="nav-link  text-dark" data-bs-toggle="dropdown"><i className='fa fa-ellipsis-v'></i></Link>
                                <div className="dropdown-menu m-0 bg-info rounded-0">
                                    <Link to="/about" className="dropdown-item"><i className='fa fa-user pe-2'></i> About Us</Link>
                                    <Link to="/contact" className="dropdown-item"><i className='fa fa-shopping-bag pe-2'></i> Contact US</Link>
                                    <Link to="/shop" className="dropdown-item"><i className='fa fa-heart pe-2'></i> Shop Now</Link>
                                    <Link to="/profile" className="dropdown-item"><i className='fa fa-user pe-2'></i> Customer Support</Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}
